import React, { useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/styles";
import { useMediaQuery } from "@material-ui/core";
import { Sidebar, Topbar, Footer } from "./components";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 0,
    height: "100%",
    [theme.breakpoints.up("sm")]: {
      paddingTop: 0,
    },
  },
  shiftContent: {
    paddingLeft: 260,
  },
  content: {
    height: "100%",
  },
}));

const PaddinglessMain = (props) => {
  const { children } = props;
  const history = useHistory();
  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"), {
    defaultMatches: true,
  });

  const [openSidebar, setOpenSidebar] = useState(false);

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  const shouldDisplaySidebar = () => {
    let href = window.location.href;
    if (
      href.split("/").pop() === "plans" ||
      href.split("/").pop() === "plans?" ||
      href.split("/").pop() === "pay" ||
      href.split("/").pop() === "pay?"
    ) {
      return false;
    } else {
      return isDesktop ? true : openSidebar;
    }
  };

  const shouldOpenSidebar = shouldDisplaySidebar();

  return (
    <div
      id="mainScreen"
      className={clsx({
        [classes.root]: true,
        [classes.shiftContent]: isDesktop && shouldOpenSidebar,
      })}
    >
      {!isDesktop && <Topbar onSidebarOpen={handleSidebarOpen} />}
      <Sidebar
        onClose={handleSidebarClose}
        open={shouldOpenSidebar}
        variant={isDesktop ? "persistent" : "temporary"}
        history={history}
      />
      <main className={classes.content}>
        {children}
        <Footer />
      </main>
    </div>
  );
};

PaddinglessMain.propTypes = {
  children: PropTypes.node,
};

export default PaddinglessMain;
